<template>
  <div class="flex justify-center items-center">
    <div
      class="relative rounded-full transition duration-200 ease-linear"
      :class="[data.status ? 'bg-sec' : 'bg-gray-400', data.containerClass]"
      :style="{ 'background-color': data.status && customColour ? customColour : '' }"
    >
      <span
        v-if="data.size === 'lg'"
        class="absolute bottom-0 font-black h-5 left-0 m-auto ml-3 text-sm top-0 select-none"
        @click="toggleSwitch()"
        >ON</span
      >
      <span
        v-if="data.size === 'lg'"
        class="absolute bottom-0 font-black h-5 right-0 m-auto mr-3 text-sm top-0 select-none"
        @click="toggleSwitch()"
        >OFF</span
      >

      <label
        :for="data.uniqueId"
        class="absolute left-0 bg-white border-2 mb-2 rounded-full transition transform duration-100 ease-linear"
        :class="[
          data.status ? 'translate-x-full border-sec' : 'translate-x-0 border-gray-400',
          data.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
          data.toggleClass,
        ]"
        :style="{ 'border-color': customColour }"
      ></label>

      <input
        type="checkbox"
        :id="data.uniqueId"
        :name="data.uniqueId"
        class="appearance-none w-full h-full active:outline-none focus:outline-none z-10"
        @click="toggleSwitch()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, onMounted } from 'vue';

const props = withDefaults(
  defineProps<{
    uniqueId: string;
    initialState: boolean;
    customColour?: string;
    size?: string;
    disabled?: boolean;
  }>(),
  { size: 'sm', disabled: false },
);

const emit = defineEmits<{
  (e: 'toggled', isEmitting: boolean, newStatus?: boolean): void;
}>();

const data = reactive<{
  status: boolean;
  size: string;
  containerClass: string;
  toggleClass: string;
  uniqueId: string;
  disabled: boolean;
}>({
  status: props.initialState,
  size: props.size,
  containerClass: 'w-12 h-6',
  toggleClass: 'w-6 h-6',
  uniqueId: props.uniqueId,
  disabled: props.disabled,
});

onMounted(() => {
  if (props.size === 'lg') {
    data.containerClass = 'w-20 h-10';
    data.toggleClass = 'w-10 h-10';
  }
});

const toggleSwitch = (isEmitting: boolean = true, newStatus?: boolean) => {
  if (!data.disabled) {
    data.status = newStatus || !data.status;
    if (isEmitting) emit('toggled', data.status);
  }
};
</script>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ToggleSwitch',
});
</script>
